import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import Chart from 'react-apexcharts';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { APIClient } from '../../../../helpers/api_helper';

export const DashboardDemographicDataChart = ({ isShow, office }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const api = new APIClient();

  let male = data?.demographic?.data?.M;
  let female = data?.demographic?.data?.F;

  const series = [
    {
      name: male?.label,
      data: male?.data,
    },
    {
      name: female?.label,
      data: female?.data,
    },
  ];

  const options = {
    chart: {
      type: 'bar',
      height: 360,
      stacked: !0,
      toolbar: {
        show: !1,
      },
    },
    colors: [`${male?.backgroundColor}`, `${female?.backgroundColor}`],
    plotOptions: {
      bar: {
        horizontal: !0,
        barHeight: '80%',
      },
    },
    dataLabels: {
      enabled: !1,
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },

    grid: {
      xaxis: {
        lines: {
          show: !1,
        },
      },
    },
    yaxis: {
      // min: -5,
      // max: 5,
      title: {
        text: 'Idade',
        style: {
          fontWeight: 600,
        },
      },
    },
    tooltip: {
      shared: !1,
      x: {
        formatter: function (val) {
          return val;
        },
      },
      y: {
        formatter: function (val) {
          return Math.abs(val);
        },
      },
    },
    xaxis: {
      categories: data?.demographic?.labels,
      // title: {
      //   text: 'Quantidade',
      //   offsetX: -30,
      //   offsetY: -5,
      // },
      labels: {
        formatter: function (val) {
          return Math.abs(val);
        },
      },
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        strokeColor: '#fff',
        radius: 12,
        offsetX: 0,
        offsetY: 0,
      },
    },
  };

  const DemographicDataChartView = () => {
    return (
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Dados Demográficos</h4>
        </CardHeader>
        <CardHeader className="p-0 border-0 bg-soft-light">
          <Row className="g-0 text-center">
            <Col xs={4} md={4} lg={4}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="854">
                    <CountUp
                      start={0}
                      end={data && data.totalLives}
                      duration={1}
                      separator="."
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Total de Vidas</p>
              </div>
            </Col>
            <Col xs={4} md={4} lg={4}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="1278">
                    <CountUp
                      start={0}
                      end={data && data.holders}
                      duration={1}
                      separator="."
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Titulares</p>
              </div>
            </Col>
            <Col xs={4} md={4} lg={4}>
              <div className="p-3 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="3">
                    <CountUp
                      start={0}
                      end={data && data.dependents}
                      duration={1}
                      separator="."
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Dependentes</p>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-0">
          <Chart
            dir="ltr"
            type="bar"
            height={400}
            series={series}
            options={options}
            className="apex-charts"
          />
        </CardBody>
      </Card>
    );
  };

  const getDemographic = async (office) => {
    await api.get(`/overview/demographic-data?office=${office}`).then((res) => {
      setData(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    getDemographic(office);
  }, [office]);

  return loading ? (
    <Col xs={12} md={6} lg={6}>
      <Card>
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={515} />
            </div>
          </Row>
        </SkeletonTheme>
      </Card>
    </Col>
  ) : isShow ? (
    <Col xs={12} md={6} lg={6}>
      <DemographicDataChartView />
    </Col>
  ) : null;
};
